import React from 'react';
import { Zap, Plus, Truck } from 'lucide-react';

const LotCard = ({ lot, onSelect, showPrices }) => {
  const formattedDate = lot.timestamp ? new Date(lot.timestamp).toLocaleString('es-AR', {
    day: '2-digit',
    month: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  }) : 'Fecha no disponible';

  const isLightning = lot.status === 'lightning' || lot.is_lightning_lot;

  return (
    <div 
      className={`bg-white dark:bg-gray-800 rounded-lg shadow-sm p-4 cursor-pointer hover:shadow border dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors relative
        ${isLightning ? 'bg-amber-50 dark:bg-amber-900/50 hover:bg-amber-100 dark:hover:bg-amber-900/70' : ''}`}
      onClick={() => onSelect(lot)}
    >
      <div className="absolute top-2 right-2 p-2 rounded-full bg-green-100 dark:bg-green-900/30 text-green-600 dark:text-green-500 hover:bg-green-200 dark:hover:bg-green-900/50 transition-colors">
        <Plus className="w-5 h-5" />
      </div>

      <div className="flex flex-col gap-2">
        {lot.title && (
          <div className="text-3xl font-bold text-gray-900 dark:text-white">
            {lot.title}
          </div>
        )}
        
        <div className={`flex items-baseline gap-2 ${!isLightning ? 'text-gray-700 dark:text-gray-200' : 'text-gray-500 dark:text-gray-400'}`}>
          <span className="text-2xl font-bold text-green-600 dark:text-green-500">{lot.quantity}</span>
          <span className="text-base">disponible</span>
        </div>

        {lot.supplier && (
          <div className="text-sm text-gray-500 dark:text-gray-400 flex items-center gap-1.5">
            <Truck className="w-4 h-4" />
            {lot.supplier}
          </div>
        )}

        <div className="flex items-center justify-between">
          <div></div>
          {showPrices && lot.averagePrice && (
            <div className="text-right">
              <div className="text-sm text-gray-500 dark:text-gray-400">Precio promedio</div>
              <div className="font-medium text-gray-900 dark:text-white">${lot.averagePrice.toLocaleString()}</div>
            </div>
          )}
        </div>

        <div className="flex items-center justify-between text-sm text-gray-500 dark:text-gray-400 mt-1">
          <div className="flex items-center gap-2">
            {lot.display_id && (
              <>
                <span className="text-base font-semibold text-gray-700 dark:text-gray-300">{lot.display_id}</span>
                {isLightning && <Zap className="w-4 h-4 text-amber-500 dark:text-amber-400" />}
              </>
            )}
          </div>
          <div className="text-xs">
            Ingreso: {formattedDate}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LotCard; 